import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查找健康数据
export function queryhealthdatabyoid (data) {
  return request({
    url: '/queryhealthdatabyoid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查找单设备睡眠带数据
export function querysleephistorydata (data) {
  return request({
    url: '/querysleephistorydata',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查找单设备雷达数据
export function queryradarhistorydata (data) {
  return request({
    url: '/queryradarhistorydata',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 旧 根据小区ID返回健康信息
export function queryhealthdatabycid (params, data) {
  params.token = getToken()
  return request({ url: '/queryhealthdatabycid', method: 'post', params, data })
}
// 新 根据小区ID返回健康信息
export function queryhealthdatabycidgrouphid (params, data) {
  params.token = getToken()
  return request({ url: '/queryhealthdatabycidgrouphid', method: 'post', params, data })
}



// WEBPACK FOOTER //
// ./src/api/health.js